import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "flex"
};
import LlTooltip from '@/components/LlTooltip.vue';
import LlTextField from '@/components/LlTextField.vue';
import { ref, computed } from 'vue';
export default {
  __name: 'ClientIdInput',
  props: {
    modelValue: String,
    items: {
      type: Array,
      default: () => []
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    id: String,
    label: String,
    info: String,
    placeholder: String,
    disabled: Boolean,
    rules: Array,
    hideDetails: Boolean,
    minWidth: {
      type: [String, Number],
      default: '240'
    },
    maxWidth: {
      type: [String, Number],
      default: '300'
    },
    dataCy: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'item-selected'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const menuOpen = ref(false);
    const isInteractingWithMenu = ref(false);
    const filteredItems = computed(() => {
      if (!props.modelValue) return props.items;
      const query = props.modelValue.toLowerCase();
      return props.items.filter(item => item[props.itemValue] && item[props.itemValue].toLowerCase().includes(query));
    });
    const showCustomOption = computed(() => {
      if (!props.modelValue) return false;
      return !props.items.some(item => item[props.itemValue] && item[props.itemValue].toLowerCase() === props.modelValue.toLowerCase());
    });
    function updateValue(value) {
      emit('update:modelValue', value);
      menuOpen.value = value && props.items.length > 0;
    }
    function handleFocus() {
      // Only open the menu if we have items or text to show
      if (props.items.length > 0 || props.modelValue) {
        menuOpen.value = true;
      }
    }
    function handleClick() {
      // Ensure menu stays open on click
      if (props.items.length > 0 || props.modelValue) {
        menuOpen.value = true;
        isInteractingWithMenu.value = true;
      }
    }
    function handleBlur() {
      // Only close the menu if we're not interacting with it
      if (!isInteractingWithMenu.value) {
        // Use a slight delay to check if the user clicked on a menu item
        setTimeout(() => {
          menuOpen.value = false;
          isInteractingWithMenu.value = false;
        }, 150);
      }
    }
    function selectItem(item) {
      emit('update:modelValue', item[props.itemValue]);
      emit('item-selected', item);
      isInteractingWithMenu.value = false;
      menuOpen.value = false;
    }
    function selectCustomValue() {
      const customItem = {
        [props.itemValue]: props.modelValue,
        [props.itemTitle]: props.modelValue,
        isCustom: true
      };
      emit('item-selected', customItem);
      isInteractingWithMenu.value = false;
      menuOpen.value = false;
    }
    return (_ctx, _cache) => {
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("div", null, [__props.label ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1)) : _createCommentVNode("", true), _createVNode(_component_v_menu, {
        modelValue: menuOpen.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => menuOpen.value = $event),
        "close-on-content-click": false,
        "nudge-width": 200,
        "offset-y": "",
        location: "bottom",
        position: "start",
        "min-width": __props.minWidth,
        "max-width": __props.maxWidth,
        "min-height": 200,
        "max-height": 400,
        "open-on-click": false,
        "open-on-focus": true,
        "close-on-back": true
      }, {
        activator: _withCtx(({
          props: menuProps
        }) => [_createElementVNode("div", _hoisted_2, [_createVNode(LlTextField, _mergeProps({
          id: __props.id
        }, menuProps, {
          "model-value": __props.modelValue,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          variant: "outlined",
          "hide-details": __props.hideDetails,
          rules: __props.rules,
          "data-cy": __props.dataCy,
          "onUpdate:modelValue": updateValue,
          onFocus: handleFocus,
          onBlur: handleBlur,
          onClick: handleClick
        }), null, 16, ["id", "model-value", "placeholder", "disabled", "hide-details", "rules", "data-cy"]), __props.info ? (_openBlock(), _createBlock(LlTooltip, {
          key: 0,
          text: __props.info,
          icon: "help",
          class: "pl-2 pt-2"
        }, null, 8, ["text"])) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [_createVNode(_component_v_list, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, item => {
            return _openBlock(), _createBlock(_component_v_list_item, {
              key: item[__props.itemValue],
              onClick: $event => selectItem(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item[__props.itemTitle]), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128)), showCustomOption.value ? (_openBlock(), _createBlock(_component_v_list_item, {
            key: 0,
            onClick: selectCustomValue
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [_createTextVNode(" Use \"" + _toDisplayString(__props.modelValue) + "\" ", 1), _createVNode(_component_v_chip, {
                size: "x-small",
                color: "primary",
                class: "ml-2"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("custom", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), filteredItems.value.length === 0 && !showCustomOption.value ? (_openBlock(), _createBlock(_component_v_list_item, {
            key: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item_title, {
              class: "text-caption text-grey"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("No matches found", -1)]))]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "min-width", "max-width"])]);
    };
  }
};